import {
  START_LOADING,
  END_LOADING,
  FETCH_ACCOUNTS,
  FETCH_ACCOUNT,
  ADD_ACCOUNT,
  UPDATE_ACCOUNT,
  DELETE_ACCOUNT,
} from "../actions/constants";

const initialState = {
  isLoading: false,
  accounts: [],
  account: null,
};

const accounts = (state = initialState, action) => {
  switch (action.type) {
    case START_LOADING:
      return { ...state, isLoading: true };
    case END_LOADING:
      return { ...state, isLoading: false };
    case FETCH_ACCOUNTS:
      return {
        ...state,
        accounts: action.payload,
        numberOfPages: 0,
      };
    case FETCH_ACCOUNT:
      return { ...state, account: action.payload };
    case ADD_ACCOUNT:
      return {
        ...state,
        accounts: [...state.accounts, action.payload],
        account: action.payload, // Assuming you want to view the newly added account
      };
    case UPDATE_ACCOUNT:
      return {
        ...state,
        accounts: state.accounts.map((account) =>
          account._id === action.payload._id ? action.payload : account
        ),
        account:
          state.account && state.account._id === action.payload._id
            ? action.payload
            : state.account,
      };
    case DELETE_ACCOUNT:
      return {
        ...state,
        accounts: state.accounts.filter(
          (account) => account._id !== action.payload
        ),
        account:
          state.account && state.account._id === action.payload
            ? null
            : state.account,
      };
    default:
      return state;
  }
};

export default accounts;
